<template lang="pug">
  ul.sortable-list
    slot
</template>

<script>
import { ContainerMixin } from 'vue-slicksort';

export default {
  mixins: [ContainerMixin],
};
</script>
